/**
 * @Description: @艾特 组件
 * @author Shi_qshan
 * @date 2022/3/15
 */
import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {Checkbox, Input, Space, Spin, Tooltip} from "antd";
import remindImg from "../../image/remind/remind.png";
import MemberCompanies from "../memberCompanies/memberCompanies";
import ZkModal from "../../../common/modal/zkModal";
import IconDeleteTag from "../../iconfont/deleteTag/deleteTag";
import CloudApi from "../../../cloud/cloud_api";
import Message from "../../../common/message";
import list from "../../../market/groupbuy/common/activityList/list";

const Remind = forwardRef((props, ref) => {
    const {chatRoomId, getRemind} = props

    const modalRef = useRef(null)

    const [checkAll, setCheckAll] = useState(false)
    const [loading, setLoading] = useState(true)
    const [searchValue, setSearchValue] = useState('')
    const [list, setList] = useState([]) // 渲染的数据
    const [data, setData] = useState([]) // 渲染的数据 备份
    const [rightArr, setRightArr] = useState([])

    // useEffect( () => {
    //     getMember()
    // }, [])

    function getMember() {
        CloudApi.getChatRoomMember(chatRoomId, data => {
            if (rightArr.length > 0) {
                rightArr.forEach(obj => {
                    data.list.forEach(item => {
                        if (obj.userId == item.userId) {
                            item.flag = true
                        }
                    })
                })
            }
            setList(data.list)
            setData(data.list)
            setLoading(false)
        }, error => {
            Message.error('群成员获取失败')
            setLoading(false)
        })
    }

    //打开艾特列表modal的回调
    function open() {
        modalRef.current.show()
        setLoading(true)
        getMember()
    }

    //点击搜索图标、清除图标，或按下回车键时的回调
    function onSearch(value, event) {
        let searchList = JSON.parse(JSON.stringify(data))
        let newList = searchList.filter(item => item.name.indexOf(value) != -1)
        // console.log('9898',value, newList)
        setList(newList)
    }

    //input的onchange
    function search(e) {
        setSearchValue(e.target.value)
    }

    //勾选onchange
    function onChange(e, type, obj) {
        let value = e.target.checked
        // console.log('9898', e, type, obj)
        if (type == 'all') {
            setCheckAll(value)
            let allList = JSON.parse(JSON.stringify(data))
            allList.forEach(item => {
                item.flag = value
            })
            setList(allList)
            setData(allList)
            setRightArr(allList.filter(item => item.flag == true))

        } else {
            //左侧勾选
            let leftArr = JSON.parse(JSON.stringify(data))
            leftArr.forEach(item => {
                if (item.userId == obj.userId) {
                    item.flag = value
                }
            })
            let isAll = leftArr.every(item => item.flag)
            setCheckAll(isAll)

            setList(leftArr)
            setData(leftArr)

            //右侧勾选的数据
            let newRight = JSON.parse(JSON.stringify(rightArr))
            if (value) {
                newRight.push(obj)
                setRightArr(newRight)
            } else {
                setRightArr(newRight.filter(item => item.userId != obj.userId))
            }
        }

    }

    //右侧删除
    function deleteRight(obj) {
        let left = JSON.parse(JSON.stringify(data))
        let right = JSON.parse(JSON.stringify(rightArr))
        left.forEach(item => {
            if (item.userId == obj.userId) {
                item.flag = false
            }
        })
        setRightArr(right.filter(item => item.userId != obj.userId))
        setList(left)
        setData(left)
    }

    //清空所有
    function deleteAll() {
        let leftArr = JSON.parse(JSON.stringify(list))
        leftArr.forEach(item => {
            item.flag = false

        })
        setList(leftArr)
        setData(leftArr)
        setRightArr([])
        setCheckAll(false)
    }

    function onOk() {
        modalRef.current.hide()
        getRemind(selectData())
    }

    function afterClose() {
        // setList([])
        // setData([])
        // setRightArr([])
    }

    //选中的数据
    function selectData() {
        let arr = JSON.parse(JSON.stringify(rightArr))
        return arr
    }

    useImperativeHandle(ref, () => ({
        selectData: selectData,
    }));

    return (
        <>
            <Tooltip placement="top" title={'@群成员'}>
                <img src={remindImg} className={'im-remind'} onClick={open}/>
            </Tooltip>

            <ZkModal title={'@群成员'} ref={modalRef} width={700} className={'modal-right-btn im-setting-modal'}
                     onOk={onOk}
                     okButtonProps={{disabled: rightArr.length == 0}}
                     afterClose={afterClose}>
                <div className={'im-remind-max'}>

                    {/*{左侧}*/}
                    <div className={'im-remind-left'}>
                        <Spin spinning={loading}>
                            <Input.Search placeholder="请输入要查找的昵称" onSearch={onSearch} allowClear style={{width: 290}}
                                          value={searchValue} onChange={search}/>
                            <Checkbox onChange={e => onChange(e, 'all', '')} checked={checkAll}
                                      style={{margin: '14px 0'}}>
                                <span className={'im-remind-all-member'}>{`全部成员（${list.length}）`}</span>
                            </Checkbox>
                            <ul className={'im-remind-list'}>
                                {
                                    list.map((item, index) => {
                                        return (
                                            <li key={index} className={'earch-max-remind'}>
                                                <label className={'check-box-content'}>
                                                    <Checkbox onChange={e => onChange(e, 'single', item)}
                                                              checked={item.flag}>
                                                    </Checkbox>
                                                    <div className={'earch-left-remind'}>
                                                        <img
                                                            src={item.avatar}/>
                                                        <div className={'earch-left-des'}>
                                                            <span>{item.name}</span>
                                                            <span
                                                                style={{color: item.corpShortName == '微信' ? '#33BA44' : '#FE9500'}}>
                                                            {item.corpShortName ? `@${item.corpShortName}` : ''}
                                                        </span>
                                                        </div>
                                                    </div>
                                                </label>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </Spin>
                    </div>

                    {/*{右侧}*/}
                    <div className={'im-remind-right'}>

                        {/*{右侧上}*/}
                        <div className={'im-remind-right-top'}>
                            <div className={'right-des'}>
                                <span>已选</span>
                                <span>{`（${rightArr.length}）`}</span>
                            </div>
                            <a onClick={deleteAll}>清空</a>
                        </div>

                        <ul className={'im-right-list'}>
                            {
                                rightArr.map((item, index) => {
                                    return (
                                        <li key={index} className={'earch-max-remind'}
                                            style={{justifyContent: 'space-between'}}>
                                            <div className={'earch-left-remind'}>
                                                <img
                                                    src={item.avatar}/>
                                                <div className={'earch-left-des'}>
                                                    <span>{item.name}</span>
                                                    <span
                                                        style={{color: item.corpShortName == '微信' ? '#33BA44' : '#FE9500'}}>
                                                        {item.corpShortName ? `@${item.corpShortName}` : ''}
                                                    </span>
                                                </div>
                                            </div>
                                            <span className={'remind-delete'}
                                                  onClick={() => deleteRight(item)}><IconDeleteTag/></span>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            </ZkModal>
        </>
    )
})

export default Remind